import { useAppTranslation } from "@/utils";
import { Button, Drawer, Flex, LegacyCard, Page, Typography, usePaypingContext } from "@payping/web-components";
import { SubLayout } from "@/components/SubLayout";
import { Close, DownloadOutlined, Walking } from "@payping/icons";
import { closeId, fileDownloadId, guideBrancesId, guideId, guideMapId } from "@/assets/googleTrackIds";
import { Link } from "react-router-dom";
import { DashboardRoutes } from "@/router";
import { buildUrl } from "@payping/utilities-shared/url";
import { URLS } from "@payping/utilities-shared/consts";
// import { DashboardRoutes } from "@/router";

const OpeningGuid = () => {
  const { t } = useAppTranslation();
  // const navigate = useNavigate();
  const { breakpoints } = usePaypingContext();
  const { md } = breakpoints;

  return (
    <Drawer
      title={<Typography.Text>{t("digitalAccount.samanBankOpeningGuid.title")}</Typography.Text>}
      open={true}
      closeIcon={false}
      placement={"bottom"}
      size={"100%"}
      extra={
        <Link to={DashboardRoutes.digitalAccount.saman.accountConnection?.url}>
          <Button type={"text"} icon={<Close width={14} height={14} />} data-google-track={closeId} />
        </Link>
      }
    >
      <Page>
        <SubLayout>
          <div className="tw:flex! tw:justify-center!">
            <Flex vertical gap={16}>
              <Typography.Title className="tw:flex! tw:justify-center!" level={4}>
                {t("digitalAccount.samanBankOpeningGuid.howToOpenTheAccount")}
              </Typography.Title>
              <LegacyCard.Ant>
                <Flex vertical gap={32}>
                  <Flex gap={"small"}>
                    <Walking fill={"primary"} width={32} />
                    <Typography.Title level={5} className={"tw:mb-0! tw:items-center"}>
                      {t("digitalAccount.samanBankOpeningGuid.visitingTheBankInPerson")}
                    </Typography.Title>
                  </Flex>
                  <Flex vertical gap={"small"}>
                    <Typography.Title level={5}>
                      {t("digitalAccount.samanBankOpeningGuid.samanJointAccountAccessForm")}
                    </Typography.Title>
                    <Typography.Text type={"secondary"} className="tw:whitespace-pre-line">
                      {t("digitalAccount.samanBankOpeningGuid.paypingInformationForm")}
                    </Typography.Text>
                    <Typography.Title level={5}>
                      {t("digitalAccount.samanBankOpeningGuid.requestAccessWebservicesPayment")}
                    </Typography.Title>
                    <Typography.Text type={"secondary"} className="tw:whitespace-pre-line">
                      {t("digitalAccount.samanBankOpeningGuid.requestAccessWebservicesPaymentDesc")}
                    </Typography.Text>
                  </Flex>
                  <Flex gap={"small"}>
                    <Button
                      target={"_blank"}
                      href={`${buildUrl(URLS.STORAGE_URL, "digitalAccount/documents/samanRequestForm.pdf").toString()}`}
                      className="tw:w-fit"
                      type={"default"}
                      icon={<DownloadOutlined width={14} height={14} />}
                      data-google-track={fileDownloadId}
                    >
                      {t("digitalAccount.samanBankOpeningGuid.getForm")}
                    </Button>
                    <Link to={DashboardRoutes.digitalAccount.saman.newAccount.bankFormGuide.url}>
                      <Button type={"link"} data-google-track={guideId}>
                        {t("digitalAccount.bankFormGuid.title")}
                      </Button>
                    </Link>
                  </Flex>
                  <Flex vertical gap={"small"}>
                    <Typography.Title level={5}>
                      {t("digitalAccount.samanBankOpeningGuid.addressOfSamanBankBranches")}
                    </Typography.Title>
                    <Typography.Text type={"secondary"}>
                      {t("digitalAccount.samanBankOpeningGuid.addressOfSamanBankBranchesDesc")}
                    </Typography.Text>
                    <Flex vertical={!md} gap={"small"}>
                      <Link to={"https://www.sb24.ir/contact-us/branches"}>
                        <Button
                          className={"tw:flex tw:justify-start tw:p-0! tw:md:p-0!"}
                          type={"link"}
                          data-google-track={guideMapId}
                        >
                          {t("digitalAccount.samanBankOpeningGuid.searchFromTheMap")}
                        </Button>
                      </Link>
                      <Link to={"https://www.sb24.ir/contact-us/branches/counties-branches"}>
                        <Button
                          className={"tw:flex tw:justify-start tw:p-0! tw:md:p-0!"}
                          type={"link"}
                          data-google-track={guideBrancesId}
                        >
                          {t("digitalAccount.samanBankOpeningGuid.ListOfOnlyCityBranches")}
                        </Button>
                      </Link>
                    </Flex>
                  </Flex>
                  <Flex vertical gap={"small"}>
                    <Typography.Title level={5}>
                      {t("digitalAccount.samanBankOpeningGuid.getUsernameAndPasswordWebservice")}
                    </Typography.Title>
                    <Typography.Text type={"secondary"}>
                      {t("digitalAccount.samanBankOpeningGuid.getUsernameAndPasswordWebserviceDesc")}
                    </Typography.Text>
                    <Typography.Title level={5}>
                      {t("digitalAccount.samanBankOpeningGuid.settingNameAndUserName")}
                    </Typography.Title>
                    <Typography.Text type={"secondary"} className="tw:whitespace-pre-line">
                      {t("digitalAccount.samanBankOpeningGuid.settingNameAndUserNameDesc")}
                    </Typography.Text>
                  </Flex>
                </Flex>
              </LegacyCard.Ant>
            </Flex>
          </div>
        </SubLayout>
      </Page>
    </Drawer>
  );
};

export default OpeningGuid;
